import React from "react";

import clsx from "clsx";

import { TertiaryButton } from "@shared/buttons";

export function DismissComponent({ onDismiss }: { onDismiss: () => void }) {
  return (
    <TertiaryButton
      onClick={onDismiss}
      className={clsx(
        "flex items-center justify-start gap-2 text-xs text-v2-primary font-bold",
        "hover:bg-transparent py-0 px-1 group/dismiss",
      )}
    >
      <span className="group-hover/dismiss:underline">DISMISS</span>
      <i
        className={clsx("fa-regular fa-x text-v2-primary font-bold text-xs")}
      ></i>
    </TertiaryButton>
  );
}
